"use strict";

import Analytics from "/js/util/analytics.js";
import AppUtil from "/js/util/app-util.js";
import Global from "/js/core/global.js";
import Strings from "/js/util/strings.js";
import Constants from "/js/core/constants.js";
import FocusUtil from '../util/focus-util';

/** 
 * Base class for interactions.
 * Gets instantiated per-interaction.
*/
export default class InteractionView {

  #$el;
  #$skipButton;

  #data;
  #answers;
  #initialAnswers;
  
  /**
   * Rem, concrete subclass instances get created by `InteractionViewUtil`.
   * Subclass should populate (append) the contents of $el after super().
   */
  constructor(data, initialAnswers=null) {
    // cl("InteractionView()", 'data:', data);
    // cl("InteractionView()", 'initialAnswers:', initialAnswers);

    this.#data = data;
    this.#initialAnswers = initialAnswers;

    let cls = data.template;
    if (cls === "multiple-image") {
      // Special case: Treat "multiple-image" as "multiple-choice", because in practice, it's just
      // an alias.
      cls = "multiple-choice";
    }
    this.#$el = $('<div />', { class: `interaction ${ cls }`} );

    // Add skip button.
    const skipText = `<div id="interactionSkip" tabindex="${Constants.TABINDEX_CONTENT_END}">${Strings.get("lesson_skip_activity_button")}</div>`;
    this.#$skipButton = $(skipText);
    this.#$skipButton.on("click tap", e => this.#onSkipButtonClick(e));
    FocusUtil.doStandardTreatment(this.#$skipButton);
    this.#$el.append(this.#$skipButton);
  }

  get $el() {
    return this.#$el;
  }

  get data() {
    return this.#data;
  }

  /**
   * Should return the user answers for the interaction.
   * The structure of this data depends on the subclass. 
   */ 
  get answers() {
    return this.#answers;
  }

  set answers(o) {
    this.#answers = o;
  }

  /**
   * The pre-existing user answers (if any), for use when instantiatng the view.
   */
  get initialAnswers() {
    return this.#initialAnswers;
  }

  resize() { }

  show() { 
    this.#$el.show();
    AppUtil.animInFromBottom(this.#$el);
  }

  hide() {
    AppUtil.animOutToTop(this.#$el);
  }

  /**
   * Should be called by subclass when the last 'step' is complete.
   * Results view get displayed using the data stored in `answers`.
   */
  finish() {
    // Note how answers array is wrapped in an object here.
    this.#$el.trigger("interaction-body-finished", { data: this.#answers });
  }

  #onSkipButtonClick(e) {
    Analytics.trackInteractionSkip(Global.lessonData.interactions, this.#data.interactionId);
    this.#$el.trigger("interaction-skip");
  }
}
